import { render, staticRenderFns } from "./SurveyFeedback.vue?vue&type=template&id=81249db6&scoped=true&"
import script from "./SurveyFeedback.vue?vue&type=script&lang=js&"
export * from "./SurveyFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81249db6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VExpandTransition,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81249db6')) {
      api.createRecord('81249db6', component.options)
    } else {
      api.reload('81249db6', component.options)
    }
    module.hot.accept("./SurveyFeedback.vue?vue&type=template&id=81249db6&scoped=true&", function () {
      api.rerender('81249db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/surveys/SurveyFeedback.vue"
export default component.exports